/// <reference path="../HierarchicalFacet/HierarchicalFacet.ts" />

import { OmniboxValuesList } from '../Facet/OmniboxValuesList';
import { FacetValue } from '../Facet/FacetValues';
import { HierarchicalFacet } from '../HierarchicalFacet/HierarchicalFacet';
import { IPopulateOmniboxObject } from '../Omnibox/OmniboxInterface';
import { OmniboxHierarchicalValueElement } from './OmniboxHierarchicalValueElement';

export class OmniboxHierarchicalValuesList extends OmniboxValuesList {
  constructor(public facet: HierarchicalFacet, public facetValues: FacetValue[], public omniboxObject: IPopulateOmniboxObject) {
    super(facet, facetValues, omniboxObject, OmniboxHierarchicalValueElement);
  }
}



/** WEBPACK FOOTER **
 ** ./src/ui/HierarchicalFacet/OmniboxHierarchicalValuesList.ts
 **/